import { Box, Grid, Typography } from '@mui/material';
import Link from 'components/Link';
import phoneIcon from 'assets/images/phone.svg';
import emailIcon from 'assets/images/email.svg';
import { TextInput } from 'components/v2/common/TextInput';
import { SubmitHandler, useForm } from 'react-hook-form';
import { CustomButton } from 'components/common';
import GoogleLogin from 'react-google-login';
import GoogleImage from 'assets/images/googleImg.png';
import { BigButton } from 'components/v2/common/Buttons/BigButton';
import { Dispatch, SetStateAction } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { ApiPostNoAuth } from 'helpers/Api/ApiData';
import { toast, ToastContainer } from 'react-toastify';
import { GoogleProfileObj, StepOneInputs } from 'pages/register';

const schema: yup.SchemaOf<StepOneInputs> = yup.object().shape({
  first_name: yup
    .string()
    .trim()
    .required('First name is required')
    .matches(/^([A-Za-z]){0}[A-Za-z]+\s*$/i, 'Invalid input'),
  last_name: yup
    .string()
    .trim()
    .required('Last name is required')
    .matches(/^[A-Za-z]+\s*$/i, 'Invalid input'),
  email: yup
    .string()
    .email('Please enter valid email address')
    .required('Email is required'),
  phone_no: yup
    .string()
    .matches(/^[0-9]{10}$/, 'Enter valid 10 digit mobile number')
    .required('Mobile no is required'),
});

interface FirstStepProps {
  setSignupType: Dispatch<SetStateAction<'gmail' | 'email' | null>>;
  setGoogleData: Dispatch<SetStateAction<GoogleProfileObj | null>>;
  setEmailSignUpData: Dispatch<SetStateAction<StepOneInputs | null>>;
}

export const FirstStep = ({
  setGoogleData,
  setSignupType,
  setEmailSignUpData,
}: FirstStepProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<StepOneInputs>({
    resolver: yupResolver(schema),
    mode: 'onTouched',
  });

  const onSubmit: SubmitHandler<StepOneInputs> = ({
    first_name,
    last_name,
    email,
    phone_no,
  }) => {
    ApiPostNoAuth(`user/check-email-or-phone`, { email, phone_no })
      .then(() => {
        setEmailSignUpData({
          first_name,
          email,
          phone_no,
          last_name,
        });
        setSignupType('email');
      })
      .catch((err) => toast.error(err.message));
  };

  const onGoogleSuccess = async (res: any) => {
    setSignupType('gmail');
    setGoogleData(res.profileObj);
  };

  console.log(errors);

  return (
    <Box>
      <ToastContainer />
      <Typography
        component="h1"
        mt="42px"
        color="#091E42"
        fontSize={28}
        fontWeight={700}
        lineHeight="32.81px"
      >
        Sign up
      </Typography>
      <Typography
        mt={1.5}
        fontSize={14}
        lineHeight="21px"
        color="rgba(0, 0, 0, 0.67)"
      >
        Sign up to create an account
      </Typography>
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <Grid container columnSpacing={2} mt="10px">
          <Grid item xs={6}>
            <TextInput
              placeholder="First Name"
              register={register('first_name')}
              errorMessage={errors.first_name?.message}
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              placeholder="Last Name"
              register={register('last_name')}
              errorMessage={errors.last_name?.message}
            />
          </Grid>
        </Grid>
        <TextInput
          sx={{ mt: '2px' }}
          placeholder="Phone No."
          icon={phoneIcon.src}
          register={register('phone_no')}
          errorMessage={errors.phone_no?.message}
          maxLength={10}
        />
        <TextInput
          sx={{ mt: '2px' }}
          placeholder="Email"
          icon={emailIcon.src}
          register={register('email', { required: true })}
          errorMessage={errors.email?.message}
        />
        <BigButton
          onClick={handleSubmit(onSubmit)}
          type="submit"
          sx={{ py: '10px', width: '100%' }}
        >
          <Typography fontWeight={700} fontSize={18}>
            NEXT
          </Typography>
        </BigButton>
        <Typography mt="17px">
          Already have an account?{' '}
          <Link sx={{ fontWeight: 700 }} noLinkStyle href="/login">
            Login
          </Link>
        </Typography>
        <Typography
          component="p"
          fontSize={14}
          lineHeight="16.41px"
          align="center"
          mt="30px"
          mb={3}
        >
          Or
        </Typography>
        <GoogleLogin
          clientId={
            '335830995858-tbi0m6n9fmf8q4nlrr5o062ebg7a8vpq.apps.googleusercontent.com'
          }
          render={(renderProps) => (
            <CustomButton
              type="button"
              sx={{
                fontSize: 20,
                width: 280,
                height: 50,
                mt: 2,
                mb: 3,
                mx: 'auto',
                background: '#4285F4',
                '&:hover': {
                  backgroundColor: '#4285F4',
                },
                display: 'flex',
                pl: 0,
              }}
              onClick={() => {
                renderProps.onClick();
              }}
              disabled={renderProps.disabled}
              // className="googleSignup"
            >
              <Box
                // className="googleIcon"
                component="small"
                flexShrink={0}
                sx={{
                  // display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#fff',
                  borderRadius: 50,
                  height: '40px',
                  width: '40px',
                  p: 0.5,
                  // mr: '40px',
                  '& img': {
                    width: '100%',
                    height: '100%',
                    m: 'auto',
                  },
                  ml: '6px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {' '}
                <img src={GoogleImage.src} alt="" />
              </Box>
              <Box ml={1} flexGrow={1}>
                Sign up with Google
              </Box>
            </CustomButton>
          )}
          buttonText=" Sign up with Google"
          onSuccess={onGoogleSuccess}
          // onFailure={onGoogleFailure}
          cookiePolicy={'single_host_origin'}
          style={{ marginTop: '100px' }}
          // isSignedIn={true}
        />
      </Box>
    </Box>
  );
};
